import { useState, useEffect } from "react";
import { clientAPI } from "@/lib/client-fetch";
import API_ENDPOINTS from "@/constants/api-endpoints";

type UseCaliiPlusMembershipResult = {
  freeTrialMonths: number;
  isLoading: boolean;
};

export function useCaliiPlusMembership(): UseCaliiPlusMembershipResult {
  const [freeTrialMonths, setFreeTrialMonths] = useState(1);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    clientAPI
      .get<{ current_offer: { free_trial_num_months: number } }>(API_ENDPOINTS.CALII_PLUS_MEMBERSHIPS)
      .then((result) => {
        if (cancelled) return;
        if (result.ok) setFreeTrialMonths(result.data.current_offer?.free_trial_num_months ?? 0);
        setIsLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  return { freeTrialMonths, isLoading };
}
